<script>
export default {
    props: {
        strong: { type: Number, default: 1 }
    },
    render(h) {
        return h('div', {
            class: [ 'title-container' ],
        }, [
            h(`h${this.strong}`, {
                class: [ 'title' ]
            }, [
                this.$slots.default
            ]),
            h('hr'),
        ]);
    }
}
</script>

<style lang="less" scoped>
.title-container {
    margin-left: 5px;
    margin-right: 5px;
}
.title {
    font-weight: bold;
    text-align: left;
    margin-left: 10px;
    margin-bottom: 0;
}
</style>